// React
import React from 'react';

// Vendors
import {
    Button,
    SectionalBanner,
    TextInput,
} from '@equisoft/design-elements-react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

// Styles
import classes from './ForgotPassword.module.scss';

const ForgotPasswordPage = () => {
    // Hooks
    const navigate = useNavigate();
    const { t } = useTranslation();

    return (
        <div className={classes.Root}>
            <div className={classes.MainContainer}>
                <h1 className={classes.Title}>
                    {t('app.page.forgot_password.title')}
                </h1>
                <form>
                    <SectionalBanner
                        type="info"
                        className={classes.SectionBanner}
                    >
                        {t('app.page.forgot_password.description')}
                    </SectionalBanner>

                    <div className={classes.ForgotPasswordForm}>
                        <TextInput
                            label={t('app.page.forgot_password.username_label')}
                            required
                        />

                        <div>
                            <Button
                                className={classes.SubmitButton}
                                buttonType="primary"
                                label={t(
                                    'app.page.forgot_password.submit_button'
                                )}
                            />
                            <Button
                                onClick={() => navigate('/login')}
                                className={classes.BackButton}
                                buttonType="tertiary"
                                label={t(
                                    'app.page.forgot_password.back_button'
                                )}
                            />
                        </div>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default ForgotPasswordPage;
